import React from 'react';
import PropTypes from 'prop-types';
import { HeaderWrapper, TopButton, Logo, SubmitButton } from './Header.styled';
import logo from '../../assets/primaryLogo.png';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { assignSessionId } from '../../features/session/sessionId';
import { useSelector, useDispatch } from 'react-redux';
import { populateInputs, clearAdvancedConfigs, resetEnableReset } from '../../features/inputs/inputs';
import { assignAnalysisPageNav } from '../../features/analysisPageNav/analysisPageNav';


function Header (props) {
   const navigate = useNavigate();
   const validInputs = useSelector((state) => state.inputs.valid);
   const enableRecalculate = useSelector((state) => state.inputs.enableRecalculate);
   const enableReset = useSelector((state) => state.inputs.enableReset);
   const token = useSelector((state) => state.token.value);
   const sessionId = useSelector((state) => state.sessionId.value);
   const dispatch = useDispatch();
   const inputs = useSelector((state) => state.inputs.value);
   const [scroll, setScroll] = React.useState(document.documentElement.scrollTop);

   const submit = (reset) => {
      dispatch(populateInputs(inputs));
      if (reset) {
         dispatch(clearAdvancedConfigs());
         dispatch(resetEnableReset(false));
      }
      if (validInputs) {
         axios.post(`${process.env.REACT_APP_API_URL}api/inputspush`,
            {...inputs, freshRun: reset},
            { headers: 
               { 
               'Authorization': `${token}`, 
               'Content-Type': 'application/json',
               'sessionId': `${sessionId}`
               }
            }
         )
         .then(response => {
            dispatch(assignSessionId(response.data['sessionId']));
            dispatch(assignAnalysisPageNav('roi'));
            navigate('/loading');
         })
         .catch(error => {
            console.error(error);
         });
      }
   }

   window.addEventListener("scroll", (event) => {
      setScroll(document.documentElement.scrollTop);
  });
 
   return (
 <HeaderWrapper minimize={scroll !== 0}>
   <TopButton
      onClick={() => window.open('https://chargeathome.org/', '_blank')}
   >
   <Logo src={logo} alt="MFH Logo"  minimize={scroll !== 0}></Logo>
   </TopButton>
   <TopButton>
      {props.page == "analysis" ? 
      <>
      <SubmitButton onClick={() => {dispatch(clearAdvancedConfigs()); submit(true)}} disabled= {!enableReset}>Reset to Initial Values</SubmitButton>
      <SubmitButton onClick={() => submit(false)} disabled = {!validInputs || !enableRecalculate}>Recalculate</SubmitButton> 
      </> : null}
      <SubmitButton onClick={() => window.open('https://chargeathome.org/glossary-of-terms/', '_blank')}>
         View Glossary
      </SubmitButton>
   </TopButton>
 </HeaderWrapper>
)};

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
